import { createAction, props } from '@ngrx/store';

export const SetNewRelicInteractionId = createAction(
  '[NewRelic] Set Interaction Id',
  props<{ interactionId: string }>()
);

export const ClearNewRelicInteractionId = createAction('[NewRelic] Clear Interaction Id');
